import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartComponent } from './bar-chart.component';
import { ChartModule } from 'angular-highcharts';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    BarChartComponent
  ],
  imports: [
    CommonModule,
    ChartModule,
    MaterialModule
  ],
  exports:[
    BarChartComponent
  ]
})
export class BarChartModule { }
